module.exports = __webpack_public_path__ + "img/chat-left-text.eb0b1d0d.svg";